import httpService from "@src/utility/httpService";
const _httpService = new httpService();
import { config } from '@uhg-abyss/web/tools/config';
import { getPSMSProviderEntityId, getGroupName } from '@src/utility/createStorage';

const apiDomainInternal = config('API_DOMAIN_INTERNAL');
if (apiDomainInternal) {
  _httpService.setBaseURL(apiDomainInternal);
  // _httpService.setBaseURL("https://uhcinsightsdev-api1.hcck8s-ctc-np1.optum.com");
}

export const providerKey = () => {
  const providerDetails = async () => {
    try {
      const providerEntityId = getPSMSProviderEntityId();

      const groupVal = sessionStorage.getItem('multiTinNavigation');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let response: Record<string, any> | null = null;
      if(!groupVal && providerEntityId){
        response= await _httpService.get(
          `providerInfoPSMS/?providerEntityId=${providerEntityId}`
        );
      } else {
        const groupName = getGroupName();
        const multiSelectedTins = sessionStorage.getItem('multiSelectedTins');
        if(multiSelectedTins && !multiSelectedTins.includes(',')){
          const fetchedProviderEntityId = await fetchProviderDetailsByTin();
          
          if (fetchedProviderEntityId) {
            response = await _httpService.get(
              `providerInfoPSMS/?providerEntityId=${fetchedProviderEntityId}`
            );
          } else {
            response = null;
          }
        }else{
            response= await _httpService.get(
              `providerInfoPSMS/?groupName=${groupName}`
            );
        }
      }

      return response;
    } catch (error) {
      console.error('Error in providerDetails:', error);
      return null;
    }
  };

  return providerDetails();
};

export const getExtendedTinList  = (tins?) => {
  const tinsDetail = tins!==null ? tins : sessionStorage.getItem('multiSelectedTins');
  const tinList = { RequestedJourney: 'provTinListFilterPSMS', ProvTinListFilter: { Tin: '' } };
    tinList.ProvTinListFilter.Tin = tinsDetail;

    const providerInputTins = { tins: [] };
    providerInputTins.tins = tinsDetail.split(',');
  const cb = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const response: Record<string, any> = await _httpService.push('/extended-tins/top-filter?items=MULTITIN', tinList);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const provideResponse: Record<string, any> = await _httpService.push('/api/providers/batch-tin-query', providerInputTins);
        response['Data'] = response['Data'].map((item) => {
        const found = provideResponse['Data'].find(
            (provider) => provider.tin === item.Tin
          );
            return {
              ...item,
              GenesisSystemID: found ? found.bicId : item.GenesisSystemID,
              GenesisProviderSystem: found ? found.providerSystem.toUpperCase() : item.GenesisProviderSystem.toUpperCase() ,
              ProviderEntityId: found ? found.ProviderEntityId : item.ProviderEntityId
            };
        });
       
        return response;
      }
      catch {
        return  null;
      }
    };
      return cb();
}

export const getProviderDetailsList  = (tins?) => {
  const tinsDetail = tins!==null ? tins : sessionStorage.getItem('multiSelectedTins');
   const tinList = { tins: [] };
    tinList.tins = tinsDetail.split(',');

  const cb = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const response: Record<string, any> = await _httpService.push('/api/providers/batch-tin-query', tinList);
        return response;
      }
      catch {
        return  null;
      }
    };
      return cb();
}

export const fetchProviderDetailsByTin = async () => {
  try {
    const multiSelectedTins = sessionStorage.getItem('multiSelectedTins');
    
    if (!multiSelectedTins) {
      return null;
    }

    const tin = multiSelectedTins.trim();
    
    if (!tin || tin === '') {
      return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: Record<string, any> = await _httpService.push('/api/providers/by-tin', {
      tin: tin
    });
  
    const data = response?.data || response?.Data;
      
    if (data?.ProviderEntityId) {
      return data.ProviderEntityId;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error in fetchProviderDetailsByTin:', error);
    return null;
  }
};
